import { doc, serverTimestamp, setDoc, updateDoc, type DocumentData } from "firebase/firestore";
import { firebase } from "@core/firebase/app";
import { firestoreService } from "@core/services/db/FirestoreService";
import type { UserProfile, UserProfileDoc } from "@core/services/models/User";
import { mapUserProfile } from "@core/services/models/User";
import type { Unsubscribe } from "firebase/firestore";

const USERS_COLLECTION = "users";

class ClientUserService {
  subscribeToProfile(userId: string, callback: (profile: UserProfile | null) => void): Unsubscribe {
    return firestoreService.subscribeToDocument(USERS_COLLECTION, userId, (docSnapshot) => {
      if (!docSnapshot) {
        callback(null);
        return;
      }
      callback(mapUserProfile(docSnapshot.id, docSnapshot as unknown as UserProfileDoc));
    });
  }

  async ensureProfile(userId: string, fallback: Partial<UserProfileDoc>): Promise<void> {
    const docSnapshot = await firestoreService.getDocument(USERS_COLLECTION, userId);
    if (docSnapshot) {
      return;
    }
    const ref = doc(firebase.firestore, USERS_COLLECTION, userId);
    await setDoc(ref, {
      ...fallback,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    } as unknown as DocumentData);
  }

  async updateProfile(userId: string, updates: Partial<UserProfileDoc>): Promise<void> {
    const ref = doc(firebase.firestore, USERS_COLLECTION, userId);
    await updateDoc(ref, {
      ...updates,
      updatedAt: serverTimestamp()
    } as unknown as DocumentData);
  }
}

export const userService = new ClientUserService();

